import React, { Fragment, useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Select, Button, Table, Typography, Tabs, Badge } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { QUANTITY } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import DailyRunRateActions from '@Actions/inventory/dailyRunRateActions';
import AddToCartActions from '../../../../../actions/addToCart/addToCartActions';
import './style.scss';

const { Text } = Typography;

const DailyRunRateView = ({ user, selectedDailyRunRate, selectedDRR, getDailyRunRateById, getDailyRunRateByIdLoading, addToCartV2, addToCartLoadingV2, callback, cartSkus, setStockTypeFilter, stockTypeFilter }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedKey, setSelectedKey] = useState('');

  useEffect(() => {
    getDailyRunRateById({ tenantId: selectedDRR?.tenant_id, drrId: selectedDRR?.drr_id });

    return () => {

    }
  }, []);

  const getStatusColor = (status) => {
    if (status === 'All') return '#2D7DF7'
    if (status === 'In Stock') return '#52C41A'
    if (status === 'Running Low') return '#FAAD14'
    if (status === 'Out of Stock') return '#FF4D4F'
  }

  const columns = [
    {
      title: 'Product',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      fixed: 'left',
      render: (record) => {
        return (
          <div style={{ width: '230px' }}>
            <Link to={`/inventory/product/view/${record?.product_sku_info?.product_sku_id}`} target="_blank">
              {record?.product_sku_info?.internal_sku_code}
            </Link>
            <span>
              {` - ${record?.product_sku_info?.ref_product_code ? `${record?.product_sku_info?.ref_product_code} - ` : ''}${record?.product_sku_info?.product_sku_name}`?.trim()}
            </span>
          </div>
        );
      },
    },
    {
      title: 'Available Qty',
      render: (item) => {
        return (`${QUANTITY((item?.product_sku_info?.total_available_qty), item?.product_sku_info?.uom_info?.precision)} ${item?.product_sku_info?.uom_info?.uqc?.toProperCase()}`);
      },
    },
    {
      title: 'Daily Run Rate',
      render: (item) => {
        return (`${QUANTITY((item?.daily_run_rate), item?.product_sku_info?.uom_info?.precision)} ${item?.product_sku_info?.uom_info?.uqc?.toProperCase()}`);
      },
    },
    {
      title: 'Days of Stock',
      render: (item) => {
        return (
          <div>
            {item?.days_of_stock !== 'Infinite' ? Helpers.convertDays(item?.days_of_stock) : '-'}
          </div >
        );
      },
    },
    {
      title: 'Minimum Floor Qty',
      render: (item) => {
        return (`${QUANTITY((item?.minimum_floor_qty), item?.product_sku_info?.uom_info?.precision)} ${item?.product_sku_info?.uom_info?.uqc?.toProperCase()}`);
      },
    },
    {
      title: 'Status',
      render: (item) => {
        return (
          <div
            className='status-tag'
            style={{ backgroundColor: getStatusColor(item?.status) }}
          >
            {item?.status}
          </div>
        );
      },
    },
  ];

  const getData = () => {
    const copyData = JSON.parse(JSON.stringify(selectedDailyRunRate?.outward_tenant_skus));
    for (let i = 0; i < copyData?.length; i++) {
      copyData[i].key = i;
    }
    return selectedKey ? copyData?.filter((item) => item?.status === selectedKey) : copyData;
  };

  return (
    <Fragment>
      <div className="view-drr__wrapper">
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        </div>
        <Tabs
          items={[
              {
                label: (
                  <span>
                    All Products&nbsp;
                    <Badge
                      count={selectedDailyRunRate?.outward_tenant_skus?.length}
                      color={getStatusColor('All')}
                      overflowCount={10000}
                      showZero={true}
                    />
                  </span>
                ),
                key: '',
              },
              {
                label: (
                  <span>
                    Out of Stock&nbsp;
                    <Badge
                      count={selectedDailyRunRate?.outward_tenant_skus?.filter((item) => item?.status === 'Out of Stock')?.length}
                      color={getStatusColor('Out of Stock')}
                      overflowCount={10000}
                      showZero={true} 
                    />
                  </span>
                ),
                key: 'Out of Stock',
              },
              {
                label: (
                  <span>
                    Running Low&nbsp;
                    <Badge
                      count={selectedDailyRunRate?.outward_tenant_skus?.filter((item) => item?.status === 'Running Low')?.length}
                      color={getStatusColor('Running Low')}
                      overflowCount={10000}
                      showZero={true}
                    />
                  </span>
                ),
                key: 'Running Low',
              },
              {
                label: (
                  <span>
                    Well Stocked&nbsp;
                    <Badge
                      count={selectedDailyRunRate?.outward_tenant_skus?.filter((item) => item?.status === 'In Stock')?.length}
                      overflowCount={10000}
                      showZero={true}
                      color={getStatusColor('In Stock')}
                    />
                  </span>
                ),
                key: 'In Stock',
          }]}
          onChange={(key) => {
            setSelectedRowKeys(null);
            setSelectedRows([]);
            setSelectedKey(key);
          }}
        />
        <Table
          rowSelection={{
            onChange: (rowKeys, rows) => {
              setSelectedRowKeys(rowKeys);
              setSelectedRows(rows);
            },
            selectedRowKeys,
            getCheckboxProps: (record) => ({
              disabled: !!cartSkus?.length ? cartSkus.includes(record?.product_sku_info?.product_sku_id) : false,
            }),
          }}
          dataSource={(selectedDailyRunRate && getData()) || []}
          columns={columns}
          loading={getDailyRunRateByIdLoading}
          size="small"
          pagination={false
          }
        />
      </div>
      <div className="custom-drawer__footer" style={{ width: '875px' }}>
        <div className="flex-display flex-align-c">
            <Button
              type="primary"
              icon={<ShoppingCartOutlined />}
              disabled={!selectedRowKeys?.length || (user?.tenant_info?.tenant_id !== selectedDRR?.tenant_id)}
              loading={addToCartLoadingV2}
              onClick={() => {
                const uniqueSkuIds = selectedRows.reduce((acc, curr) => {
                  const skuId = curr?.product_sku_info?.product_sku_id;
                  return !acc.includes(skuId) ? [...acc, skuId] : acc;
                }, []);

                const payload = {
                  tenant_id: user?.tenant_info?.tenant_id,
                  product_sku_ids: [...uniqueSkuIds],
                };
                addToCartV2(payload, () => {
                  setSelectedRowKeys(null);
                  setSelectedRows([]);
                  callback()
                });
              }}
            >
              Add to cart
            </Button>
            &nbsp;&nbsp;
            {selectedRows?.length > 0 ? `${selectedRows?.length} Product(s) selected` : ''}
          </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, DailyRunRateReducers, AddToCartReducers }) => ({
  user: UserReducers.user,
  selectedDailyRunRate: DailyRunRateReducers.selectedDailyRunRate,
  getDailyRunRateByIdLoading: DailyRunRateReducers.getDailyRunRateByIdLoading,
  addToCartLoadingV2: AddToCartReducers.addToCartLoadingV2,
});

const mapDispatchToProps = (dispatch) => ({
  getDailyRunRateById: (payload, callback) => dispatch(DailyRunRateActions.getDailyRunRateById(payload, callback)),
  addToCartV2: (payload, callback) => dispatch(AddToCartActions.addToCartV2(payload, callback)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(DailyRunRateView));
